export default __webpack_public_path__ + "static/media/Snd_Try7.7b4a225a.mp3";